<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div  class="btn-box">
        <el-date-picker v-model="timeValue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <button-add :pathName="addPathName" style="margin-left: 10px;" v-if="permissionCodes.indexOf('033009001') !== -1"/>
      </div>

      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="报警设备" @search="searchKey" />
        <!--<button-export-->
        <!--:href="exportUrl"-->
        <!--download="download.xls"-->
        <!--:beforeDownload="beforeDownload"-->
        <!--value="导出"/>-->
      </div>
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="报警类型" :selectKey="'alarmType'" :selectData="alarmTypeList" @search="search" />
        <input-select selectTitle="所属场所" :selectKey="'placeCode'" :selectData="sceneList" @search="search" style="margin-left: 10px;"/>
      </div>
      <input-select selectTitle="报警状态" :selectKey="'alarmStatus'" :selectData="alarmStatusList" @search="search"/>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SmartDetection";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "smart-detection-alarm-record",
  data() {
    return {
      permissionCodes: "",
      addPathName: "smart-detection-alarm-record-add",
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "报警记录"
        }
      ],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      exportUrl: "",

      tableHead: [
        {
          prop: "deviceName",
          label: "报警设备"
        },
        {
          prop: "alarmType",
          label: "报警类型"
        },
        {
          prop: "deviceName",
          label: "所属场所"
        },
        {
          prop: "alarmStatus",
          label: "报警状态",
          width: '120px'
        },
        {
          prop: "numericalValue",
          label: "数值",
          width: '120px'
        },
        {
          prop: "numericalValue",
          label: "正常范围",
          width: '120px'
        },
        {
          prop: "alarmTime",
          label: "报警时间"
        },
        {
          prop: "describe",
          label: "报警描述",
          width: '280px'
        },
        {
          prop: "alarmReleaseTime",
          label: "报警解除时间"
        },
        {
          prop: "processingCycle",
          label: "处理时间(分钟)"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      sceneList: [],
      alarmStatusList: [
        {key: '', label: '全部'},
        {key: '报警中', label: '报警中'},
        {key: '已解除', label: '已解除'},
      ],
      alarmTypeList: [
        {key: '', label: '全部'},
        {key: '液位报警', label: '液位报警'},
        {key: '液压报警', label: '液压报警'},
        {key: '温湿度报警', label: '温湿度报警'},
        {key: '水质报警', label: '水质报警'},
        {key: '电压/电流报警', label: '电压/电流报警'},
        {key: '风速报警', label: '风速报警'},
        {key: '气压报警', label: '气压报警'},
        {key: '高度报警', label: '高度报警'},
        {key: '水浸报警', label: '水浸报警'},
        {key: '气体报警', label: '气体报警'},
        {key: '配电报警', label: '配电报警'},
        {key: '泵状态报警', label: '泵状态报警'},
      ],
      requestData: {
        searchKey: "",
        alarmStatus: "",
        alarmType: ''
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    // this.exportUrl = `${api.exportElectricControlDeviceStatus}?yq-app-code=${bus.global.yqCode}&kj-type=gy&searchKey=${this.requestData.searchKey}`
    this.getCurrentTime();
    this.getPlaceList()
  },
  activated() {
    this.getCurrentTime();
  },
  methods: {
    getPlaceList(searchKey) {
      this.$axios
        .post(api.getPlaceList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.name;
            });
            this.sceneList = list;
            this.sceneList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getCurrentTime() {
      this.timeValue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timeValue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timeValue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    beforeDownload() {
      if (this.timeValue.length > 0) {
        this.exportUrl = `${
          api.exportElectricControlDeviceStatus
        }?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${
          bus.global.token
        }&searchKey=${this.requestData.searchKey}&alarmStatus=${
          this.requestData.alarmStatus
        }&startTime=${this.timeValue[0]} 00:00:00&endTime=${
          this.timeValue[1]
        } 23:59:59`;
      } else {
        this.exportUrl = `${
          api.exportElectricControlDeviceStatus
        }?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${
          bus.global.token
        }&searchKey=${this.requestData.searchKey}&alarmStatus=${
          this.requestData.alarmStatus
        }`;
      }
    },
    // 获取状态日志
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue) {
        reqData.startTime = this.timeValue[0];
        reqData.endTime = this.timeValue[1];
      } else {
        reqData.startTime = "";
        reqData.endTime = "";
      }
      this.$axios
        .post(api.getEnergyAlarmRecordPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    }
  },
  watch: {
    timeValue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionAlarm/SmartDetectionAlarmRecord.vue